import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import usePatientPayTable from "./hooks/usePatientPayTable";
import MinMaxList from "./MinMaxList";

const PatientPayTable = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectParamsData,
  onNavigate,
}) => {
  const patientPayTableData = usePatientPayTable(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectParamsData,
    onNavigate
  );

  return (
    <div class="container container-fluid">
      <MinMaxList
        visible={patientPayTableData.dialogVisible}
        onHide={() => patientPayTableData.setDialogVisible(false)}
        selectedRows={patientPayTableData.selectedRows}
        rowData={[patientPayTableData.rowData]}
        prevScreen={patientPayTableData.previousScreen}
        paramsData={patientPayTableData.paramsDataForMinMax}
        selectMode={patientPayTableData.selectMode}
        onNavigate={onNavigate}
      />
      <ButtonsSection
        ctaButtons={patientPayTableData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {patientPayTableData.screen_title} -{" "}
          <span className="heading-cod">
            {patientPayTableData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={patientPayTableData.formFields}
        dropdownValues={patientPayTableData.dropdownValues}
        paramsData={patientPayTableData.paramsData}
        updataParamData={patientPayTableData.updateParamData}
      />
      <ButtonsSection ctaButtons={patientPayTableData.ctaButtons} />
      <DisplayTable
        selectMode={patientPayTableData.selectMode}
        data={patientPayTableData.data}
        parmKey={patientPayTableData.parmKey}
        menuOptions={patientPayTableData.menuOptions}
        tableHeaders={patientPayTableData.columnDef}
        setRowData={patientPayTableData.setRowData}
        selectedPriceSchedules={patientPayTableData.selectedRows}
        setSelectedPriceSchedules={patientPayTableData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={patientPayTableData.first}
          rows={patientPayTableData.rows}
          totalRecords={patientPayTableData.totalRecords}
          currentPage={patientPayTableData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={patientPayTableData.onPageChange}
        />
      </div>
      {patientPayTableData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={patientPayTableData.isConfirmationModalOpen}
          onRequestClose={patientPayTableData.closeConfirmationModal}
          onBack={patientPayTableData.closeConfirmationModal}
          onSave={patientPayTableData.deletePatientPayTable}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={patientPayTableData.setSelectedOption}
        />
      )}
      {patientPayTableData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={patientPayTableData.isHideConfirmationModalOpen}
          onRequestClose={patientPayTableData.closeHideConfirmationModal}
          onBack={patientPayTableData.closeHideConfirmationModal}
          onSave={patientPayTableData.hidePatientPayTable}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={patientPayTableData.setHideSelectedOption}
        />
      )}
    </div>
  );
};

export default PatientPayTable;
